import React from 'react'
import Logo from '../assets/pplogo.png'
import { useTranslation } from '../hooks/useTranslation'
import { Button } from '../components/primitives'
import Card from '../components/primitives/Card'
import { useNavigate } from 'react-router-dom'

export default function InvoiceFailed() {
    const t = useTranslation();
    const navigate = useNavigate();
    return (
        <div className="auth-page">
            <div className="auth-outer-container">
                <div className="logo-group">
                    <img className="logo-signin" src={Logo} alt="Page Parrot Logo"/>
                    <h2 className="logo-heading w-900 text-center">{t('Page Parrot')}</h2>
                </div>
                <Card ctype="auth-container centered">
                    <h1 className="text-center">Outstanding Invoice</h1>
                    <p className="text-center">Your latest invoice has failed to process. Please update your payment method to continue using Page Parrot.</p>
                    <Button onClick={() => navigate('/auth/resubscribe')}>Update Payment Details</Button>
                </Card>
            </div>
        </div>
    )
}
